<div class="service-authorization-dialog">
  <div class="service-authorization-dialog-header flex-between-center">
    <div style="display: grid">
      <p class="m-0 font-bold font-18"
        *ngIf="!MFCValidations && !showInvoiceButton() && !showAuthorizeButton(); else infoRequired">
        Optional Payment Information</p>
      <ng-template #infoRequired>
        <p class="m-0 font-bold font-18" *ngIf="!MFCValidations">Information required for {{ showInvoiceButton() ?
          'invoice' :
          showAuthorizeButton() ? 'authorization' : 'payment' }}</p>

        <p class="m-0 font-bold font-18" *ngIf="MFCValidations">Information required for posting to MyFleetCenter </p>
      </ng-template>
      <p *ngIf="!MFCValidations">
        <!-- {{!showInvoiceButton() && !showAuthorizeButton() ? 'Optional:' : ''}} -->
        Please complete the vehicle{{
        !checkVehicleInfoWithoutService() ? ' and authorization' : '' }} {{
        showInvoiceButton() && isPartsOrderingExist ? 'and parts ordering' : '' }} details below to
        proceed to {{ showInvoiceButton() ? 'invoice' : showAuthorizeButton() ? 'authorization' : 'payment' }}.
        <br />
        <span class="font-red" *ngIf="depositRequest && openFrom === 'invoice'">
          Note: Estimate deposit request of {{ depositRequest.amount || 0 | currency : usd }} will be automatically
          canceled due to Invoicing.</span>
        <i *ngIf="isFetchingData" class="p-2 fal fa-spinner rotate"></i>
      </p>

      <p *ngIf="MFCValidations">
        {{MfcSubtitle}}
      </p>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div *ngIf="isFetchingData" class="loading-body flex-center-center h-200">
    <i class="p-2 fal fa-spinner rotate"></i>
  </div>
  <div *ngIf="!isFetchingData && !isSyncingToQuickbooks" class="service-authorization-dialog-body pt-0"
    [ngClass]="!processStepperValue.processAuthorizedBtn && 'h-100'">
    <div *ngIf="processStepperValue.tabStep" class="service-tab-header">
      <ul>
        <!-- <li *ngIf="order.vehicle">
          <div class="tab-head" [ngClass]="[requiredVinMilage && !processStepperValue.vehicleInfoCompleted
            && hasRequiredServiceCheck ? 'in-complete' : 'complete']">
            <div class="tab-icon" [ngClass]="{ 'warning-icon': !isVinMandatory && !isMileageMandatory &&
               !processStepperValue.vehicleInfoCompleted }">
              <i class="far" [ngClass]="{
                  'fa-check': processStepperValue.vehicleInfoCompleted,
                  'fa-exclamation-circle': !processStepperValue.vehicleInfoCompleted && (isVinMandatory || isMileageMandatory),
                  'fa-ellipsis-h': !isVinMandatory && !isMileageMandatory && !processStepperValue.vehicleInfoCompleted
                }"></i>
            </div>
            <h3>Vehicle</h3>
          </div>
        </li> -->

        <li *ngIf="order.vehicle?.name">
          <div class="tab-head" [ngClass]="getVehicleInfoClass()">
            <div class="tab-icon" [ngClass]="getVehicleIconClass()">
              <i class="far" [ngClass]="getVehicleIconType()"></i>
            </div>
            <h3>Vehicle</h3>
          </div>
        </li>

        <!-- Driver -->
        <li *ngIf="vehicle?._id && order?.customer?.isFleetCustomer && isMyFleetCenterEnabled">
          <div class="tab-head" [ngClass]="getDriverInfoClass()">
            <div class="tab-icon">
              <i class="far" [ngClass]="getDriverIconType()"></i>
            </div>
            <h3>Driver</h3>
          </div>
        </li>

        <!-- Authorization -->
        <li *ngIf="!checkVehicleInfoWithoutService()">
          <div class="tab-head" [ngClass]="getAuthorizationClass()">
            <div class="tab-icon">
              <i class="far" [ngClass]="getAuthorizationIconType()"></i>
            </div>
            <h3>Authorization</h3>
          </div>
        </li>

        <!-- dot number -->
        <li
          *ngIf="isDotNumberReqOnInv && (showInvoiceButton() || this.openFrom === 'finalization') && order?.dotNumberServices?.length">
          <div class="tab-head"
            [ngClass]="[this.openFrom === 'payment' ? 'complete' : !processStepperValue.tiresDotNumberCompleted ? 'in-complete' : 'complete']">
            <div class="tab-icon">
              <i class="far"
                [ngClass]="[processStepperValue.tiresDotNumberCompleted ? 'fa-check' : 'fa-exclamation-circle']"></i>
            </div>
            <h3>DOT Number</h3>
          </div>
        </li>
        <!-- dot number end -->
        <!-- Sales Code -->
        <li *ngIf="isNewItemCategoriesEnable && isSalesCodeEnabled && unassignedServices.length">
          <div class="tab-head" [ngClass]="getSalesCodeClass()">
            <div class="tab-icon">
              <i class="far" [ngClass]="getSalesCodeIconType()"></i>
            </div>
            <h3>Sales Code</h3>
          </div>
        </li>

        <li *ngIf="isPartWarrantiesEnabled && unassignedWarrantyServices.length">
          <div class="tab-head" [ngClass]="getWarrantyClass()">
            <div class="tab-icon">
              <i class="far" [ngClass]="getWarrantyIconType()"></i>
            </div>
            <h3>Warranty Assignment</h3>
          </div>
        </li>

        <!-- Item classification -->
        <!-- Commenting the code from here in html file for sale code item classification as this is no longer required as pe Product Owner -->
        <!-- <li *ngIf="isNewItemCategoriesEnable && orderItems.length">
          <div class="tab-head"
            [ngClass]="[this.openFrom === 'payment' || this.openFrom === 'authorize' ? 'complete' : !processStepperValue.itemClassificationCompleted ? 'in-complete' : 'complete']">
            <div class="tab-icon">
              <i class="far"
                [ngClass]="[processStepperValue.itemClassificationCompleted ? 'fa-check' : 'fa-exclamation-circle']"></i>
            </div>
            <h3>Item Classification</h3>
          </div>
        </li> -->
        <!-- Item classification end -->
        <li *ngIf="hasRequiredServiceCheck && isPartsOrderingExist && showInvoiceButton()">
          <div class="tab-head" [ngClass]="isOrderPlaced && 'complete'">
            <div class="tab-icon" [ngClass]="!isOrderPlaced && 'warning-icon'">
              <i class="far" [ngClass]="isOrderPlaced ? 'fa-check' : 'fa-ellipsis-h'"></i>
            </div>
            <h3>Part Ordering</h3>
          </div>
        </li>
        <li *ngIf="showInvoiceButton() && hasItemWithCore">
          <div class="tab-head in-complete">
            <div class="tab-icon warning-icon">
              <i class="far fa-ellipsis-h"></i>
            </div>
            <h3>Core</h3>
          </div>
        </li>

        <li *ngIf="showInvoiceButton() && hasCreditLimitSection && !isRevenueRecognitionSettleEnabled">
          <div class="tab-head" [ngClass]="isValidSafeToInvoice() ? 'in-complete' : 'complete'">
            <div class="tab-icon">
              <i class="far" [ngClass]="!isValidSafeToInvoice() ? 'fa-check' : 'fa-exclamation-circle'"></i>
            </div>
            <h3>Credit Limit</h3>
          </div>
        </li>
      </ul>
    </div>


    <!-- Vehicle INFO -->
    <div class="vehicle-info" *ngIf="processStepperValue.vehicleInfo && !isSyncingToQuickbooks && order.vehicle?.name"
      [ngClass]="!processStepperValue.vehicleInfoBody && 'close-accordion'">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <i *ngIf="!processingVin" [ngClass]="getVinIconClass()"></i>

          <span class="fa-stack" *ngIf="showEllipsisIcon()">
            <i class="fa-ellipsis-h fa-stack-1x far"></i>
          </span>

          <i class="fal fa-spinner rotate" *ngIf="processingVin"></i>
          <div class="vehicle-heading">
            <h3>
              Vehicle information
              <span class="pill pill-recomended flex-center-center"
                *ngIf="!isVinMandatory && !isMileageMandatory && !processStepperValue.vehicleInfoCompleted">Recommended</span>
            </h3>
            <p class="m-0 font-gray-55"
              *ngIf="getVehicleRequiredValidation() || !processStepperValue.vehicleInfoCompleted">
              {{ requiredVinMilage ? 'Please provide these details for' : 'Would you like to provide these details for'
              }} {{ order?.vehicle?.name }}?
            </p>
            <p class="m-0 font-gray-55"
              *ngIf="!getVehicleRequiredValidation() && processStepperValue.vehicleInfoCompleted">Great job! All
              required vehicle
              information fields are completed.</p>
          </div>
        </div>
        <div class="flex-center-center">
          <!-- <button class="btn btn-update" (click)="onSubmitMilage()" [disabled]="checkDefaultVehicleInfo()" [hidden]="!processStepperValue.vehicleInfoBody">
            <span [ngClass]="[isProcessingAuthorization ? 'pr-2' : '', checkDefaultVehicleInfo() ? 'gray-65' : 'primary-color']">Confirm and Update</span>
            <i class="fal fa-spinner rotate" *ngIf="processingVin"></i>
          </button> -->
          <i (click)="$event.stopPropagation(); stepProcessor('vehicleInfoBody', true)" class="pl-2 fa"
            [ngClass]="[processStepperValue.vehicleInfoBody ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </div>
      <div class="vehicle-body">
        <!-- Start------- Normal Vehicle Information ---------- -->
        <div class="row" *ngIf="processStepperValue.vehicleInfoBody && !customer.isMFCustomer">
          <div [ngClass]="isTrackMileageInAndOut ? 'col-md-4' : 'col-md-6'">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-car" [ngClass]="{
                    'text-red': isVinMandatory && !data.vin && !showAuthorizeButton() && !showPaymentButton(),
                    'font-gray-35': processStepperValue.vehicleInfoCompleted
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input type="text" theme="primary" [placeholder]="vinPlaceholder" [autoFocus]="focus?.vin"
                  [disabled]="isFinalizedRo" [maxLength]="17" [fontSize]="14" [floatingLabel]="true" [value]="data.vin"
                  [isInvalid]="errors?.vin || (isVinMandatory && !data.vin && !showAuthorizeButton() && !showPaymentButton())"
                  (appChange)="handleChangeVin('vin', $event)" (appFocus)="handleFocus('vin')"
                  (appBlur)="handleBlur('vin')" (appOnInputChange)="handleChangeInput()">
                  <!-- [errorMessage]="errors?.vin" -->
                </app-input>
              </div>
            </div>
          </div>
          <div [ngClass]="isTrackMileageInAndOut ? 'col-md-4' : 'col-md-6'">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-tachometer" [ngClass]="{
                    'text-red': isMileageMandatory && !data.mileage && !showAuthorizeButton() && !showPaymentButton(),
                    'font-gray-35': processStepperValue.vehicleInfoCompleted
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input theme="primary" mask="00000000" [placeholder]="mileagePlaceholder"
                  [autoFocus]="focus?.mileage" [disabled]="isFinalizedRo" [fontSize]="12" [value]="data.mileage"
                  [floatingLabel]="true"
                  [isInvalid]="errors?.mileage || (isMileageMandatory && !data.mileage && !showAuthorizeButton() && !showPaymentButton())"
                  (appBlur)="handleBlur('mileage')" (appChange)="handleChangeVin('mileage', $event)"
                  (appOnInputChange)="handleChangeInput()" styleClass="h-33">
                  <!-- [errorMessage]="errors?.mileage" -->
                </app-input>
              </div>
            </div>
          </div>
          <div class="col-md-4" *ngIf="isTrackMileageInAndOut">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-tachometer" [ngClass]="{
                    'text-red': isTrackMileageInAndOut && !data.mileageOut && !this.showAuthorizeButton() && !this.showPaymentButton(),
                    'font-gray-35': processStepperValue.vehicleInfoCompleted
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input theme="primary" mask="00000000" [placeholder]="mileageOutPlaceholder"
                  [autoFocus]="focus?.mileageOut" [disabled]="isFinalizedRo" [fontSize]="12" [value]="data.mileageOut"
                  [floatingLabel]="true" [errorMessage]="errors?.mileageOut"
                  [isInvalid]="errors?.mileageOut || (isTrackMileageInAndOut && !data.mileageOut && !this.showAuthorizeButton() && !this.showPaymentButton())"
                  (appBlur)="handleBlur('mileageOut')" (appChange)="handleChangeVin('mileageOut', $event)"
                  styleClass="h-31" (appOnInputChange)="handleChangeInput()">
                  <!-- [errorMessage]="errors?.mileageOut" -->
                </app-input>
              </div>
            </div>
          </div>
        </div>
        <!-- End------- Normal Vehicle Information ---------- -->


        <!-- Start------- My Fleet Center Information ---------- -->
        <div class="row" *ngIf="processStepperValue.vehicleInfoBody && customer?.isFleetCustomer &&
          isMyFleetCenterEnabled && customer?.isMFCustomer">
          <div class="col-md-4">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-calendar-alt" [ngClass]="{
                  'text-red': getErrorMessageValidation('year'),
                  'font-gray-35': vehicle.year
                }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input type="text" theme="primary" placeholder="Year ({{getFieldValidationStatus('year')}})"
                  [autoFocus]="focus?.year" [maxLength]="17" [fontSize]="14" [floatingLabel]="true"
                  [isInvalid]="getErrorMessageValidation('year')" [value]="vehicle.year" [disabled]="disabled?.year"
                  (appChange)="handleChangeFleetVehicle('year', $event)" (appFocus)="handleFocus('year')"
                  (appBlur)="handleBlur('year')" (appOnInputChange)="handleChangeInput(true)">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-tools" [ngClass]="{
                  'text-red': getErrorMessageValidation('make'),
                  'font-gray-35': vehicle.make
                }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input type="text" theme="primary" placeholder="Make ({{getFieldValidationStatus('make')}})"
                  [maxLength]="17" [fontSize]="14" [floatingLabel]="true" [value]="vehicle.make"
                  [isInvalid]="getErrorMessageValidation('make')" [disabled]="disabled?.make"
                  (appChange)="handleChangeFleetVehicle('make', $event)" (appFocus)="handleFocus('make')"
                  (appBlur)="handleBlur('make')" [autoFocus]="focus?.make" (appOnInputChange)="handleChangeInput(true)">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-car-mechanic" [ngClass]="{
                  'text-red': getErrorMessageValidation('model'),
                  'font-gray-35': vehicle.model
                }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input type="text" theme="primary" placeholder="Model ({{getFieldValidationStatus('model')}})"
                  [maxLength]="17" [fontSize]="14" [floatingLabel]="true" [value]="vehicle.model"
                  [isInvalid]="getErrorMessageValidation('model')" [disabled]="disabled?.model"
                  (appChange)="handleChangeFleetVehicle('model', $event)" (appFocus)="handleFocus('model')"
                  (appBlur)="handleBlur('model')" [autoFocus]="focus?.model"
                  (appOnInputChange)="handleChangeInput(true)">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-5">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-car" [ngClass]="{
                    'text-red': getErrorMessageValidation('vin') || isVinMandatory && !data.vin && !showAuthorizeButton() && !showPaymentButton(),
                    'font-gray-35': data.vin
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-input type="text" theme="primary" [placeholder]="vinPlaceholder" [autoFocus]="focus?.vin"
                  [disabled]="isFinalizedRo" [maxLength]="17" [fontSize]="14" [floatingLabel]="true" [value]="data.vin"
                  [isInvalid]="getErrorMessageValidation('vin') || errors?.vin || (isVinMandatory && !data.vin && !showAuthorizeButton() && !showPaymentButton())"
                  (appChange)="handleChangeVin('vin', $event)" (appFocus)="handleFocus('vin')"
                  (appBlur)="handleBlur('vin')" (appOnInputChange)="handleChangeInput()">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-5 pl-2">
            <div class="input-style-wrapper-icon w-100">
              <div class="align-self-center font-14">
                <div class="custom-button license-plate" [ngClass]="{
                  'text-red red-license-icon': getErrorMessageValidation('licensePlateNo'),
                  'font-gray-35': vehicle.licensePlateNo
                }">
                  123
                </div>
              </div>

              <div class="input-wrapper small pl-2">
                <app-input type="text" theme="primary"
                  placeholder="License plate number ({{getFieldValidationStatus('licensePlateNo')}})" [maxLength]="17"
                  [fontSize]="14" [floatingLabel]="true" [value]="vehicle.licensePlateNo"
                  [isInvalid]="getErrorMessageValidation('licensePlateNo')" [autoFocus]="focus?.licensePlateNo"
                  (appChange)="handleChangeFleetVehicle('licensePlateNo', $event)"
                  (appFocus)="handleFocus('licensePlateNo')" (appBlur)="handleBlur('licensePlateNo')"
                  (appOnInputChange)="handleChangeInput(true)">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-5">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-cars" [ngClass]="{
                    'text-red': getErrorMessageValidation('unitNumber'),
                    'font-gray-35': vehicle.unitNumber
                  }"></i>
              </div>

              <div class="input-wrapper small">
                <app-input type="text" theme="primary"
                  placeholder="Vehicle unit number ({{getFieldValidationStatus('unitNumber')}})" [maxLength]="17"
                  [isInvalid]="getErrorMessageValidation('unitNumber')" [fontSize]="14" [floatingLabel]="true"
                  [value]="vehicle.unitNumber" [autoFocus]="focus?.unitNumber"
                  (appChange)="handleChangeFleetVehicle('unitNumber', $event)" (appFocus)="handleFocus('unitNumber')"
                  (appBlur)="handleBlur('unitNumber')" (appOnInputChange)="handleChangeInput(true)">
                </app-input>
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-5">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-tachometer" [ngClass]="{
                    'text-red': getErrorMessageValidation('mileage') || isMileageMandatory && !data.mileage && !showAuthorizeButton() && !showPaymentButton(),
                    'font-gray-35': data.mileage
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <!-- [isInvalid]="" -->
                <app-input theme="primary" mask="00000000" [placeholder]="mileagePlaceholder"
                  [autoFocus]="focus?.mileage" [disabled]="isFinalizedRo" [fontSize]="12" [value]="data.mileage"
                  [floatingLabel]="true"
                  [isInvalid]="getErrorMessageValidation('mileage') || errors?.mileage || (isMileageMandatory && !data.mileage && !showAuthorizeButton() && !showPaymentButton())"
                  (appBlur)="handleBlur('mileage')" (appChange)="handleChangeVin('mileage', $event)"
                  (appOnInputChange)="handleChangeInput()" styleClass="h-33">
                </app-input>
              </div>
            </div>
          </div>
          <div class="col-md-4 mt-5" *ngIf="isTrackMileageInAndOut">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-tachometer" [ngClass]="{
                    'text-red': getErrorMessageValidation('mileageOut') || isTrackMileageInAndOut && !data.mileageOut && !this.showAuthorizeButton() && !this.showPaymentButton(),
                    'font-gray-35': processStepperValue.mileageOut
                  }"></i>
              </div>

              <div class="input-wrapper small">
                <app-input theme="primary" mask="00000000" [placeholder]="mileageOutPlaceholder"
                  [autoFocus]="focus?.mileageOut" [disabled]="isFinalizedRo" [fontSize]="12" [value]="data.mileageOut"
                  [floatingLabel]="true" [errorMessage]="errors?.mileageOut"
                  [isInvalid]="getErrorMessageValidation('mileageOut') || errors?.mileageOut || (isTrackMileageInAndOut && !data.mileageOut && !this.showAuthorizeButton() && !this.showPaymentButton())"
                  (appBlur)="handleBlur('mileageOut')" (appChange)="handleChangeVin('mileageOut', $event)"
                  styleClass="h-31" (appOnInputChange)="handleChangeInput()">
                </app-input>
              </div>
            </div>
          </div>
        </div>
        <!-- End------- My Fleet Center Information ---------- -->


      </div>
    </div>
    <!-- Vehicle INFO-END -->


    <!-- Driver INFO -->
    <div class="vehicle-info" *ngIf="vehicle?._id && order?.customer?.isFleetCustomer && isMyFleetCenterEnabled"
      [ngClass]="!processStepperValue.driverInfoBody && 'close-accordion'">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <i *ngIf="!isProcessingDriver" [ngClass]="getDriverIconClass()">
          </i>

          <i class="fal fa-spinner rotate" *ngIf="isProcessingDriver"></i>

          <div class="vehicle-heading" (click)="$event.stopPropagation(); stepProcessor('driverInfoBody', true)">
            <h3>
              Driver details
              <!-- <span class="pill pill-recomended flex-center-center"
                *ngIf="!getDriverRequiredValidation() && !processStepperValue.driverInfoCompleted">Recommended</span> -->
            </h3>
            <p class="m-0 font-gray-55" *ngIf="!processStepperValue.driverInfoCompleted">
              Please enter all driver details to proceed.
            </p>
            <p class="m-0 font-gray-55" *ngIf="processStepperValue.driverInfoCompleted">Great job! All required driver
              information fields are completed.</p>
          </div>
        </div>
        <div class="flex-center-center">
          <i class="pl-2 fa" (click)="$event.stopPropagation(); stepProcessor('driverInfoBody', true)"
            [ngClass]="[processStepperValue.driverInfoBody ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </div>
      <div class="vehicle-body" [hidden]="!processStepperValue.driverInfoBody">
        <div class="row">
          <div [ngClass]="isTrackMileageInAndOut ? 'col-md-4' : 'col-md-6'">
            <div class="input-style-wrapper-icon w-100">
              <div class="icon-wrapper align-self-center font-14">
                <i class="far fa-car" [ngClass]="{
                    'text-red': getDriverRequiredValidation(),
                    'font-gray-35': vehicle?.driver
                  }"></i>
              </div>

              <div class="input-wrapper small pl-1">
                <app-dropdown placeholder="Select Driver" scrollHeight="120px" field="fullName"
                  [closeOnSelection]="true" [floatingLabel]="true" [hasEditableField]="false" [value]="vehicle?.driver"
                  [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [setPositionDynamically]="true"
                  [truncateString]="true" [fontSize]="14" [listItemFontSize]="14" [options]="drivers"
                  (appSelect)="onVehicleDriverSelect($event, 'tags')">
                  <ng-template let-item appTemplate="item">
                    <div class="flex-between-center font-14 font-secondary font-400">
                      <div>
                        {{ item?.fullName }}
                      </div>
                      <div *ngIf="item?.employeeNumber">
                        #{{ item?.employeeNumber }}
                      </div>
                    </div>
                  </ng-template>
                </app-dropdown>
                <!--

                <app-dropdown id="vehicle-driver" placeholder="Select Driver" theme="primary" field="fullName"
                  [fontSize]="14" [value]="vehicle?.driver" [listItemFontSize]="13" [floatingLabel]="true"
                  [options]="drivers" [isDropdownIconVisible]="true" (appSelect)="onVehicleDriverSelect($event)">
                </app-dropdown> -->
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="input-style-wrapper-icon w-100 align-items-center">
              <div class="icon-wrapper align-self-center font-14 p-2">
                <button id="driver-update-btn-add" type="button" class="btn btn-primary btn-add-driver"
                  (click)="onAddDriver()">
                  <i class="fas fa-plus pr-2"></i>
                  <span>
                    Driver
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="pl-2 driver-form">
            <p class="driver-heading">Overview</p>

            <div class="ui-g-12 p-0">
              <!-- name -->
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="driver-update-fullName"
                    [isInvalid]="getErrorMessageValidation('fullName') || errors.fullName"
                    [value]="vehicle?.driver?.fullName === 'No driver' ? '' : vehicle?.driver?.fullName" name="fullName"
                    theme="primary" placeholder="Name*" [fontSize]="14" [maxLength]="25"
                    [errorMessage]="errors.fullName" [disabled]="isDisableDriverFormFields"
                    (appChange)="handleDriverFormChange('fullName', $event)" [floatingLabel]="true"></app-input>
                </div>
              </div>
              <!-- employee-number -->
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="driver-update-employee-number" name="employee-number"
                    [value]="vehicle?.driver?.employeeNumber" theme="primary" placeholder="Employee number (optional)"
                    [fontSize]="14" [maxLength]="25" (appChange)="handleDriverFormChange('employeeNumber', $event)"
                    [disabled]="isDisableDriverFormFields" [floatingLabel]="true"></app-input>
                </div>
              </div>
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="driver-update-service-card-number" name="service-card-number" theme="primary"
                    placeholder="Service Card Number ({{getFieldValidationStatus('serviceCardNumber')}})"
                    [fontSize]="14" [isInvalid]="getErrorMessageValidation('serviceCardNumber')" [maxLength]="25"
                    [value]="vehicle?.driver?.serviceCardNumber" [disabled]="isDisableDriverFormFields"
                    (appChange)="handleDriverFormChange('serviceCardNumber', $event)"
                    [floatingLabel]="true"></app-input>
                </div>
              </div>
            </div>


            <div class="ui-g-12 p-0 pb-5 mt-3">
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="driver-update-company-name" name="company-name" theme="primary"
                    placeholder="Company Name ({{getFieldValidationStatus('companyName')}})"
                    [isInvalid]="getErrorMessageValidation('companyName')" [fontSize]="14" [maxLength]="25"
                    [value]="vehicle?.driver?.companyName" (appChange)="handleDriverFormChange('companyName', $event)"
                    [disabled]="isDisableDriverFormFields" [floatingLabel]="true"></app-input>
                </div>
              </div>
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="driver-update-department" name="department" theme="primary"
                    placeholder="Department (optional)" [fontSize]="14" [maxLength]="25"
                    (appChange)="handleDriverFormChange('department', $event)" [value]="vehicle?.driver?.department"
                    [disabled]="isDisableDriverFormFields" [floatingLabel]="true"></app-input>
                </div>
              </div>
            </div>

            <p class="driver-heading">Contact Details</p>

            <div class="ui-g-12 p-0">
              <!-- Address -->
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <!-- <app-input id="driver-update-address" name="addLine1" theme="primary" placeholder="Address (optional)"
                  [value]="vehicle?.driver?.address?.addLine1" [fontSize]="14" [maxLength]="25"
                  (appChange)="handleDriverFormChange('address.addLine1', $event)" [floatingLabel]="true"></app-input>
              -->
                  <app-input id="driver-update-address" [value]="vehicle?.driver?.address?.addLine1" name="addLine1"
                    theme="primary" placeholder="Address (optional)" [fontSize]="14" [maxLength]="25"
                    (appChange)="handleDriverFormChange('address.addLine1', $event)"
                    [isInvalid]="errors['address.addLine1']" [errorMessage]="errors['address.addLine1']"
                    [disabled]="isDisableDriverFormFields" [floatingLabel]="true"></app-input>


                </div>
              </div>
              <!-- City -->
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">

                  <app-input id="customer-update-zip1" name="zip" theme="primary" placeholder="Zip / Postal code"
                    [floatingLabel]="true" [fontSize]="14" [maxLength]="7" [isInvalid]="errors?.zip"
                    [errorMessage]="errors?.zip" [value]="vehicle?.driver?.address?.zip"
                    (appChange)="handleDriverFormChange('address.zip', $event)" (appFocus)="handleFocus('zip')"
                    [disabled]="isDisableDriverFormFields" (appBlur)="handleBlur('address')">
                  </app-input>

                  <!-- <app-input id="driver-update-city" name="city" theme="primary" placeholder="City (optional)"
                  [fontSize]="14" [maxLength]="25" (appChange)="handleDriverFormChange('address.city', $event)"
                  [value]="vehicle?.driver?.address?.city" [floatingLabel]="true"></app-input> -->
                </div>
              </div>

              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-auto-complete id="customer-update-city1" listId="customer-update-city1-list"
                    placeholder="Search city" label="City" theme="primary" field="city" [floatingLabel]="true"
                    [fontSize]="14" [suggestions]="addressCityResults"
                    [value]="renderCityName(vehicle?.driver?.address?.city,vehicle?.driver?.address?.stateCode)"
                    [disabled]="isDisableDriverFormFields" (appSelect)="onAddressCitySelect($event, 'address')"
                    (appCompletedMethod)="onAddressCitySearch($event, 'primary')"
                    (appClear)="onAddressClear('primary')">
                    <ng-template let-item appTemplate="item">
                      <div class="flex-between-center">
                        <div class="font-14">
                          {{ item.city }}, {{ item?.stateCode }}
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>
              </div>
            </div>

            <div class="ui-g-12 p-0 mt-3">

              <!-- ZIP -->

              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <!-- <app-input id="customer-update-zip1" name="zip" theme="primary"
                  placeholder="Zip / Postal code (optional)" [floatingLabel]="true" [fontSize]="14" [maxLength]="7"
                  [value]="vehicle?.driver?.address?.zip" (appChange)="handleChange('address.zip', $event)"
                  (appFocus)="handleFocus('zip')" (appBlur)="handleBlur('address')">
                </app-input> -->

                  <app-input id="driver-update-state" [value]="vehicle?.driver?.address?.state" name="state"
                    theme="primary" placeholder="State" [fontSize]="14" [maxLength]="25"
                    (appChange)="handleDriverFormChange('address.state', $event)" [isInvalid]="errors['address.state']"
                    [disabled]="isDisableDriverFormFields" [errorMessage]="errors['address.state']"
                    [floatingLabel]="true"></app-input>

                </div>
              </div>

              <!-- phone-number -->
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <app-input id="customer-update-phone" name="phone" theme="primary" mask="(000) 000-0000"
                    placeholder="Phone" [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.phone"
                    [errorMessage]="errors?.phone" [maxLength]="25" [value]="vehicle?.driver?.phone"
                    (appChange)="handleDriverFormChange('phone', $event)" (appFocus)="handleFocus('phone')"
                    [disabled]="isDisableDriverFormFields" (appBlur)="handleBlur('phone')">
                  </app-input>
                </div>
              </div>
              <div class="ui-g-4 p-0 pr-4 mt-3">
                <div class="">
                  <!-- <app-input id="driver-update-email" name="email" theme="primary" placeholder="Email Address (optional)"
                  [fontSize]="14" [maxLength]="25" (appChange)="handleChange('email', $event)"
                  [value]="vehicle?.driver?.email" [floatingLabel]="true"></app-input> -->
                  <app-input id="driver-update-email" [value]="vehicle?.driver?.email" name="email" theme="primary"
                    placeholder="Email Address" [fontSize]="14" [maxLength]="50"
                    (appChange)="handleDriverFormChange('email', $event)" [isInvalid]="errors.email"
                    [disabled]="isDisableDriverFormFields" [errorMessage]="errors.email"
                    [floatingLabel]="true"></app-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Driver INFO-END -->

    <!-- Authorization Start -->
    <div class="vehicle-info"
      *ngIf="processStepperValue.authorization && !isSyncingToQuickbooks && !checkVehicleInfoWithoutService()"
      [ngClass]="!processStepperValue.authorizationBody && 'close-accordion'">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <i *ngIf="!isProcessingAuthorization" [ngClass]="getAuthorizationIconClass()"></i>

          <i *ngIf="isProcessingAuthorization" class="fal fa-spinner rotate"></i>
          <div class="vehicle-heading">
            <h3>
              Authorization details
            </h3>

            <p *ngIf="!processStepperValue.authorizationCompleted && !showPaymentButton()" class="m-0 font-gray-55">
              Please complete authorization of all services to proceed to invoice.
            </p>
            <p *ngIf="!processStepperValue.authorizationCompleted && showPaymentButton()" class="m-0 font-gray-55">
              Would you like to complete the authorization of the services below before proceeding to payment?
            </p>

            <p *ngIf="processStepperValue.authorizationCompleted" class="m-0 font-gray-55">
              <span *ngIf="showInvoiceButton()">
                Great job! You have selected Authorization status for all services. This selection will be
                automatically
                saved once you Invoice the RO.
              </span>

              <span *ngIf="!showInvoiceButton()">
                Great job! Authorization has been updated for all services on this estimate.
              </span>
            </p>
          </div>
        </div>

        <div class="flex-center-center">
          <button class="btn btn-update"
            [hidden]="showInvoiceButton() || !hasRequiredServiceCheck || !processStepperValue.authorizationBody"
            [disabled]="isValidateAuthorizeButton()" (click)="handleSubmit()">
            <span
              [ngClass]="[isProcessingAuthorization ? 'pr-2' : '', isValidateAuthorizeButton() ? 'gray-65' : 'primary-color']">
              Authorize
            </span>
            <i class="fal fa-spinner rotate" *ngIf="isProcessingAuthorization"></i>
          </button>
          <i (click)="$event.stopPropagation(); stepProcessor('authorizationBody', true)" class="pl-2 fa"
            [ngClass]="[processStepperValue.authorizationBody ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </div>

      <div class="vehicle-body" [hidden]="!processStepperValue.authorizationBody">
        <div class="service-wrapper width-100p">
          <div class="service-main-header flex-between-center width-100p">
            <p class="m-0 font-bold font-15 font-secondary-800">Service</p>

            <div class="flex-end-center" [ngClass]="{'disabled-estimate-field': isLoading}">
              <p class="m-0 font-bold mr-2">Mark all pending as:</p>
              <button class="btn btn-border mr-2" [disabled]="disableAuthenticationOptions()"
                [ngClass]="{ 'not-allowed': disableAuthenticationOptions() }"
                (click)="handleAllServiceStatusSelect(serviceAuthConsts.approved)">
                Approve
              </button>

              <button class="btn btn-border mr-2" [disabled]="disableAuthenticationOptions()"
                [ngClass]="{ 'not-allowed': disableAuthenticationOptions() }"
                (click)="handleAllServiceStatusSelect(serviceAuthConsts.deferred)">
                Defer
              </button>

              <button class="btn btn-border" [disabled]="disableAuthenticationOptions()"
                [ngClass]="{ 'not-allowed': disableAuthenticationOptions() }"
                (click)="handleAllServiceStatusSelect(serviceAuthConsts.declined)">
                Decline
              </button>
            </div>
          </div>

          <div class="service-main-body flex-column width-100p">
            <!-- Service rows -->
            <div *ngFor="let service of order?.services; let serviceIndex = index" class="service-row width-100p">
              <div class="ui-g p-0">
                <div class="ui-g-12 p-0">
                  <!-- Service details -->
                  <div class="ui-lg-7 ui-g-12 flex-column p-0">
                    <p class="m-0 font-13 font-bold">{{ service?.title }}</p>

                    <div class="font-11 font-gray-65">
                      <span class="labor pr-2">
                        <i class="fal fa-clock"></i>
                        {{ service?.itemCount?.labor }} ({{ service?.serviceTotal?.labor | currency : usd }})
                      </span>

                      <span class="part pr-2">
                        <i class="fal fa-tools"></i>
                        {{ service?.itemCount?.part }} ({{ service?.serviceTotal?.part | currency : usd }})
                      </span>

                      <span class="tire pr-2">
                        <i class="fal fa-tire"></i>
                        {{ service?.itemCount?.tire }} ({{ service?.serviceTotal?.tire | currency : usd }})
                      </span>

                      <span *ngIf="isTireStorageEnabled" class="tireStorage pr-2">
                        <i class="fal fa-inventory"></i>
                        {{ service?.itemCount?.tireStorage }} ({{ service?.serviceTotal?.tireStorage | currency : usd
                        }})
                      </span>

                      <span class="rss_feed pr-2">
                        <i class="far fa-usd-circle"></i>
                        {{ service?.itemCount?.hazmatFee }} ({{ service?.serviceTotal?.hazmatFee | currency : usd }})
                      </span>

                      <span class="other pr-2">
                        <i class="far fa-list-alt"></i>
                        {{ service?.itemCount?.other }} ({{ service?.serviceTotal?.other | currency : usd }})
                      </span>
                    </div>
                  </div>

                  <!-- Service actions -->
                  <div class="ui-lg-5 ui-g-12 mt-lg-0 mt-2 gx-2 flex-wrap p-0 flex-end-center" [ngClass]="{'disabled-estimate-field': isLoading}"
                    [hidden]="service?.serviceStatus === serviceAuthConsts.deferredLocked">
                    <div tooltipPosition="bottom" [pTooltip]="authorizeServiceTooltip(service)">
                      <button class="btn btn-border btn-approve"
                        [disabled]="order?.isArchived || order?.orderStatus === 'invoice' || isFinalizedRo"
                        [ngClass]="{ active: serviceStatus[service?._id] === serviceAuthConsts.approved }"
                        (click)="handleServiceStatusSelect(service?._id, serviceAuthConsts.approved, serviceIndex)">
                        Approve
                      </button>
                    </div>

                    <div tooltipPosition="bottom" [pTooltip]="authorizeServiceTooltip(service)">
                      <button class="btn btn-border btn-defer"
                        [disabled]="order?.isArchived || order?.orderStatus === 'invoice' || isFinalizedRo"
                        [ngClass]="{ active: serviceStatus[service?._id] === serviceAuthConsts.deferred }"
                        (click)="handleServiceStatusSelect(service?._id, serviceAuthConsts.deferred, serviceIndex)">
                        Defer
                      </button>
                    </div>

                    <div tooltipPosition="bottom" [pTooltip]="authorizeServiceTooltip(service)">
                      <button class="btn btn-border btn-decline"
                        [disabled]="order?.isArchived || order?.orderStatus === 'invoice' || isFinalizedRo"
                        [ngClass]="{ active: serviceStatus[service?._id] === serviceAuthConsts.declined }"
                        (click)="handleServiceStatusSelect(service?._id, serviceAuthConsts.declined, serviceIndex)">
                        Decline
                      </button>
                    </div>

                    <p class="service-total m-0 font-13 font-bold text-right">
                      {{ service?.serviceTotal?.total | currency : usd }}
                    </p>
                  </div>

                  <div class="ui-g-5 p-0 flex-end-center"
                    [hidden]="service?.serviceStatus !== serviceAuthConsts.deferredLocked">
                    <button class="btn btn-border btn-approve" [disabled]="true"
                      [ngClass]="{ active: serviceStatus[service?._id] === serviceAuthConsts.approved }">
                      Deferred to RO# {{ service?.deferredFromEstimate?.estimateCode }}
                    </button>

                    <p class="service-total m-0 font-13 font-bold text-right">
                      {{ service?.serviceTotal?.total | currency : usd }}
                    </p>
                  </div>
                </div>

                <!-- Service history -->
                <div class="ui-g-12 p-0 flex-start-center">
                  <p class="font-11 font-bold pr-2 m-0">History</p>
                  <div class="service-history-line width-100p"></div>
                </div>

                <div class="ui-g-12 p-0 font-11 flex-start-center width-100p font-gray-65 history-line-item"
                  *ngFor="let history of service?.serviceAuthHistory">
                  <div class="history-time flex-start-center">
                    <i class="fal fa-{{ serviceAuthIcons[history?.status] }} pr-2"></i>

                    <p class="m-0">
                      {{ history?.createdAt | date : 'MMM d, yyyy hh:mma' }}
                    </p>
                  </div>

                  <div class="history-method text-truncate">
                    {{ history?.methodText }}
                  </div>

                  <div class="history-created-by text-truncate">by {{ history?.fullName }}</div>

                  <div class="history-total">
                    {{ history?.serviceTotal || 0 | currency : usd }}
                  </div>

                  <div class="history-notes text-truncate" tooltipPosition="top" [pTooltip]="history?.notes">
                    {{ history?.notes }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="customer-wrapper mt-2">
          <div class="customer-section-header flex-between-center width-100p">
            <p *ngIf="!customer?.isMFCustomer" class="m-0 font-bold font-15 font-secondary-800">Customer: {{
              order?.customer?.displayName }}</p>

            <div *ngIf="customer?.isMFCustomer" class="m-0 font-bold font-15 font-secondary-800">
              <div>
                Authorizer details
              </div>
              <div class="font-12 font-gray-600 font-400">
                Please contact {{customer?.phone || 'N/A'}} or {{customer?.email || 'N/A'}} to get the authorization
                details for these
                repairs.
              </div>
            </div>

            <p class="m-0 font-bold"
              (click)="openCustomerSidebar(order?.total?.grand > availableLimit && customerHasChargeAccount && isChargeAccountEnabled && !isUnlimited)"
              [pTooltip]="(order?.total?.grand > availableLimit && customerHasChargeAccount && isChargeAccountEnabled && !isUnlimited) ? tooltip : ''"
              tooltipPosition="top" [escape]="false" tooltipStyleClass="ticket-tooltip modifier pinned"
              [ngClass]="{'warning-800 pointer': (order?.total?.grand > availableLimit && customerHasChargeAccount && isChargeAccountEnabled && !isUnlimited) }">
              Total: {{ order?.total?.grand | currency : usd }}
            </p>
          </div>


          <div class="customer-section-body ui-g" [ngClass]="{ 'disabled-modal': !hasChanges || order?.isArchived }">
            <div class="ui-g-12 p-0 mb-3 d-flex flex-wrap">
              <div class="ui-g-12" [ngClass]="isDisplayAuthLogs ? 'ui-lg-4' : 'ui-lg-6'">
                <div class="customer-calendar-wrapper">
                  <div class="calendar-input mr-2">
                    <p class="mb-1 font-12 font-gray-45">Date*</p>

                    <div class="payment-date-auth">
                      <p-calendar placeholder="" appendTo="body" [disabled]="!hasChanges || order?.isArchived" [minDate]="minAuthDate"
                        [(ngModel)]="authDate" dateFormat="M dd, yy" (onSelect)="handleChange('date', $event)">
                      </p-calendar>
                    </div>
                  </div>

                  <div class="calendar-input">
                    <p class="mb-1 font-12 font-gray-45">Time*</p>

                    <div class="time-dropdown">
                      <kendo-timepicker [disabled]="!hasChanges || order?.isArchived" [(value)]="authTime"
                        [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-lg-0 mt-2 px-0" [ngClass]="isDisplayAuthLogs ? 'ui-lg-5 ui-g-8' : 'ui-lg-6 ui-g-12'">
                <div class="customer-calendar-method switch-style-secondary switch-style-secondary-no-icon">
                  <p class="mb-1 font-12 font-gray-45">Method*</p>
                  <app-switch-button id="service-auth-method-filter-switch" field="label" valueField="value"
                    paddingClass="p-1" [disabled]="!hasChanges || order?.isArchived" [fontSize]="14"
                    [showselectedCircle]="false" [value]="activeAuthMethod" [showIcons]="true" [options]="authMethods"
                    (appChange)="handleChange('activeAuthMethod', $event)">
                  </app-switch-button>
                </div>
              </div>
              <div *ngIf="isDisplayAuthLogs" class="ui-lg-3 ui-g-4">
                <p class="mb-1 font-12 font-gray-45">{{ activeAuthMethod.value === 'email' ? 'Email*' : 'Phone*' }}
                </p>
                <app-auto-complete styleClassInput="p-6p pl-0" styleClassInputWrapper="pl-0 border-padding-a"
                  styleClassListWrapper="top-38" styleClassError="top-35 left-10" itemWidth="300px" scrollHeight="184px"
                  hPosition="left" [placeholder]="activeAuthMethod.value === 'email' ? 'Select email' : 'Select phone'"
                  [selectTextOnFocus]="true" [disabled]="activeAuthMethod.value === 'inPerson' ? true : false"
                  [maxAutoGrowHeight]="96" [showDisabledIcon]="false"
                  (appSelect)="handleChange('selectedMethodValue', $event?.value)" [isDropdownIconVisible]="true"
                  [value]="selectedMethodValue" readonly="true"
                  [mask]="activeAuthMethod.value === 'sms' || activeAuthMethod.value === 'phone' ? '(000) 000-0000' : ''"
                  [fontSize]="12" [suggestions]="methodValues" [closeOnSelection]="true">
                  <ng-template appTemplate="item" let-item let-query="query">
                    <div class="flex-between-center">
                      <div *ngIf="activeAuthMethod.value !== 'email'">
                        <span class="capitalize">{{ item.contactType }}:</span>
                        <span style="font-weight: bold">{{ item.value | mask : '(000) 000-0000' }}</span>
                      </div>
                      <div *ngIf="activeAuthMethod.value === 'email'">
                        <span style="font-weight: bold">{{ item.value }}</span>
                      </div>
                      <div>
                        <span *ngIf="item.isPrimary" style="font-style: italic">Primary</span>
                      </div>
                    </div>
                    <span [ngClass]="item.isActive ? 'text-green' : 'font-orange'">{{ item.isActive ? 'Active' :
                      'Inactive' }}</span>
                  </ng-template>
                </app-auto-complete>
              </div>
            </div>
            <div class="ui-g-12 p-0" *ngIf="order?.customer?.isFleetCustomer && isMyFleetCenterEnabled">
              <div class="ui-g-2 p-0 pr-2 mb-15 disabled-mfc">
                <label class="font-12">Fleet number ({{getFieldValidationStatus('fleetNumber')}})</label>
                <app-input name="employee-number" [value]="fleetNumber" theme="border"
                  (appChange)="handleChange('fleetNumber', $event)" [disabled]="true"
                  [isInvalid]="getErrorMessageValidation('fleetNumber')"
                  placeholder="Fleet number ({{getFieldValidationStatus('fleetNumber')}})" [fontSize]="14"
                  [maxLength]="25"></app-input>
              </div>
              <div class="ui-g-2 p-0 pr-2 mb-15">
                <label class="font-12">PO number ({{getFieldValidationStatus('poNumber')}})</label>
                <app-input name="employee-PO" [value]="poNumber" theme="primary"
                  (appChange)="handleChange('poNumber', $event)" [isInvalid]="getErrorMessageValidation('poNumber')"
                  placeholder="PO number ({{getFieldValidationStatus('poNumber')}})" [fontSize]="14" [maxLength]="25"
                  theme="border"></app-input>
              </div>
              <div class="ui-g-4 p-0 pr-2 mb-15">
                <label class="font-12">Authorization number ({{getFieldValidationStatus('authorizeNumber')}})</label>
                <app-input name="employee-Authorization" [value]="authorizeNumber" theme="border"
                  (appChange)="handleChange('authorizeNumber', $event)"
                  [isInvalid]="getErrorMessageValidation('authorizeNumber')"
                  placeholder="Authorization number ({{getFieldValidationStatus('authorizeNumber')}})" [fontSize]="14"
                  [maxLength]="25"></app-input>
              </div>
              <div class="ui-g-4 p-0 pr-2 mb-15 disabled-mfc">
                <label class="font-12">Authorizer name (optional)</label>
                <app-input name="employee-Authorizer" [value]="authorizedBy" theme="border"
                  [disabled]="customer?.MFC?.authorizerDetails?.name" (appChange)="handleChange('authorizedBy', $event)"
                  placeholder="Authorizer name (optional)" [fontSize]="14" [maxLength]="25"></app-input>
              </div>

              <div class="ui-g-12 p-0 pr-2 mb-15 disabled-mfc" *ngIf="appendEmptyCodeDisplays()">
                <label class="font-12">Other requirements&nbsp;
                  <i class="fal fa-info-circle font-gray-55" tooltipPosition="top"
                    tooltipStyleClass="requirement-my-fleet-tooltip" [pTooltip]="customer?.otherRequirementTooltip"></i>
                </label>
                <app-textarea theme="border" [value]="appendEmptyCodeDisplays()" [disabled]="true"
                  [rows]="4"></app-textarea>
              </div>
            </div>

            <div class="ui-g-12 p-0 flex-column">
              <p class="mb-1 font-12 font-bold fong-gray-45">Note</p>
              <app-textarea placeholder="" theme="border" [value]="notes" [disabled]="order?.isArchived" [rows]="4"
                (appChange)="notes = $event"></app-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Authorization END -->


    <!-- Start Sales Code -->
    <ng-container *ngIf="isNewItemCategoriesEnable && isSalesCodeEnabled && unassignedServices?.length">
      <div class="vehicle-info sales-code-border" [ngClass]="!processStepperValue.salesCodeBody && 'close-accordion'">

        <!-- Sales code Header -->
        <div class="vehicle-head">
          <div class="vehicle-title">
            <i [ngClass]="getSalesCodeIconClass()"></i>

            <div class="vehicle-heading">
              <h3>Sales code assignment</h3>

              <ng-container *ngIf="!processStepperValue.salesCodeCompleted">
                <p *ngIf="!showPaymentButton() && !showAuthorizeButton()" class="m-0 font-gray-55">
                  Please add sales code for all the items listed before invoicing.
                </p>

                <p *ngIf="(showPaymentButton() && !showAuthorizeButton())" class="m-0 font-gray-55">
                  Would you like to complete sales code assignment for all the items before proceeding to payment?
                </p>

                <p *ngIf="(!showPaymentButton() && showAuthorizeButton())" class="m-0 font-gray-55">
                  Please complete sales code assignment for all the items
                </p>
              </ng-container>

              <p *ngIf="processStepperValue.salesCodeCompleted" class="m-0 font-gray-55">
                <span>
                  Great job! Sales code has been assigned to all items.
                </span>
              </p>
            </div>
          </div>

          <div class="flex-start-center">
            <div *ngIf="!processStepperValue.salesCodeCompleted"
              class="flex-center-center sales-code-assign pointer font-14 font-600"
              (click)="openAssignAllSalesCodeModal('sales-code')">
              <i class="far fa-plus"></i>
              Assign All Sales Codes
            </div>
            <div class="flex-center-center">
              <i class="pl-2 fa pointer" [ngClass]="processStepperValue.salesCodeBody ? 'fa-angle-up' : 'fa-angle-down'"
                (click)="$event.stopPropagation(); stepProcessor('salesCodeBody', true)"></i>
            </div>
          </div>
        </div>

        <div class="sales-code-body flex-column" [hidden]="!processStepperValue.salesCodeBody">
          <app-authorization-sales-code-assignment [services]="unassignedServices"
            [assignedSalesCodeItems]="assignedSalesCodeItems" type="sales-code"
            [isFinalizedRo]="isFinalizedRo"></app-authorization-sales-code-assignment>
        </div>
      </div>
    </ng-container>
    <!-- End Sales Code -->

    <!-- Start Warranty Assignment Code -->
    <ng-container *ngIf="isPartWarrantiesEnabled && unassignedWarrantyServices?.length">
      <div class="vehicle-info sales-code-border" [ngClass]="!processStepperValue.warrantyBody && 'close-accordion'">

        <!-- Sales code Header -->
        <div class="vehicle-head">
          <div class="vehicle-title">
            <i [ngClass]="getWarrantyIconClass()"></i>

            <div class="vehicle-heading">
              <h3>Warranty assignment</h3>

              <ng-container *ngIf="!processStepperValue.warrantyCompleted">
                <p *ngIf="!showPaymentButton() && !showAuthorizeButton()" class="m-0 font-gray-55">
                  Please add warranties for the items listed before invoicing
                </p>

                <p *ngIf="(showPaymentButton() && !showAuthorizeButton())" class="m-0 font-gray-55">
                  Would you like to complete warranties assignment for all the items before proceeding to payment?
                </p>

                <p *ngIf="(!showPaymentButton() && showAuthorizeButton())" class="m-0 font-gray-55">
                  Please complete warranties assignment for all the items
                </p>
              </ng-container>

              <p *ngIf="processStepperValue.warrantyCompleted" class="m-0 font-gray-55">
                <span>
                  Great job! Warranties have been added for all the listed items.
                </span>
              </p>
            </div>
          </div>

          <div class="flex-start-center">
            <div *ngIf="!processStepperValue.warrantyCompleted"
              class="flex-center-center sales-code-assign pointer font-14 font-600"
              (click)="openAssignAllSalesCodeModal('warranty')">
              <i class="far fa-plus"></i>
              Assign All Warranties
            </div>
            <div class="flex-center-center">
              <i class="pl-2 fa pointer" [ngClass]="processStepperValue.warrantyBody ? 'fa-angle-up' : 'fa-angle-down'"
                (click)="$event.stopPropagation(); stepProcessor('warrantyBody', true)"></i>
            </div>
          </div>
        </div>

        <div class="sales-code-body flex-column" [hidden]="!processStepperValue.warrantyBody">
          <app-authorization-sales-code-assignment [services]="unassignedWarrantyServices"
            [assignedSalesCodeItems]="assignedSalesCodeItems" type="warranty"
            [isFinalizedRo]="isFinalizedRo"></app-authorization-sales-code-assignment>
        </div>
      </div>
    </ng-container>
    <!-- End Sales Code -->

    <!-- DOT Number start -->
    <div class="vehicle-info" [ngClass]="!processStepperValue.tiresDotNumberInfoBody && 'close-accordion'"
      *ngIf="isDotNumberReqOnInv &&  (showInvoiceButton() || this.openFrom === 'finalization' || this.openFrom === 'payment') && order?.dotNumberServices?.length">
      <!-- main header -->
      <div class="vehicle-head">
        <div class="vehicle-title">
          <i *ngIf="!isProcessingDotNumber" [ngClass]="[
              this.openFrom === 'payment' && !processStepperValue.tiresDotNumberCompleted ? 'far fa-exclamation-circle' :
              !processStepperValue.tiresDotNumberCompleted ? 'text-red far fa-exclamation-circle ' :
              processStepperValue.tiresDotNumberCompleted ? 'fas fa-check-circle check-circle-icon' : ''
            ]"></i>


          <i *ngIf="isProcessingDotNumber" class="fal fa-spinner rotate"></i>
          <div class="vehicle-heading">
            <h3>
              Tires DOT#
            </h3>

            <p *ngIf="!processStepperValue.tiresDotNumberCompleted && !showPaymentButton()" class="m-0 font-gray-55">
              Please enter DOT numbers for all approved tires to proceed to invoice.
            </p>
            <p *ngIf="!processStepperValue.tiresDotNumberCompleted && showPaymentButton()" class="m-0 font-gray-55">
              Would you like to enter DOT numbers for teh approved tires on the order?
            </p>

            <p *ngIf="processStepperValue.tiresDotNumberCompleted" class="m-0 font-gray-55">
              <span *ngIf="!showInvoiceButton()">
                Great job! All required DOT numbers are added.
              </span>
            </p>
          </div>
        </div>
        <div class="flex-center-center">
          <i (click)="$event.stopPropagation(); stepProcessor('tiresDotNumberInfoBody', true)" class="pl-2 fa"
            [ngClass]="processStepperValue.tiresDotNumberInfoBody ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
      </div>

      <div class="vehicle-body" [hidden]="!processStepperValue.tiresDotNumberInfoBody">
        <app-authorization-tire-dot-number [isArchived]="order.isArchived" [estimateId]="this.estimateId"
          [dotNumberServices]="order?.dotNumberServices" [isFinalizedRo]="isFinalizedRo"
          (evaluateTireDotNumber)="evaluateTireDotNumber($event)"></app-authorization-tire-dot-number>
      </div>
    </div>
    <!-- DOT number end -->

    <!-- Customer section -->

    <!--
       PARTS ORDERING START
       Here we are only using functions for parts ordering
      -->

    <div class="vehicle-info"
      *ngIf="hasRequiredServiceCheck && isPartsOrderingExist && !isSyncingToQuickbooks && showInvoiceButton()">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <span class="fa-stack" [ngClass]="isOrderPlaced && 'border-none'">
            <i
              [ngClass]="isOrderPlaced ? 'fas fa-check-circle check-circle-icon' : 'fa-ellipsis-h fa-stack-1x far text-red'"></i>
          </span>

          <div class="vehicle-heading">
            <h3>
              Part Ordering
              <span class="pill pill-recomended flex-center-center" *ngIf="!isOrderPlaced">
                Recommended
              </span>
            </h3>

            <p class="m-0 font-gray-55" *ngIf="isOrderPlaced">
              Great job! There are no unsubmitted parts on this estimate
            </p>

            <p class="m-0 font-gray-55" *ngIf="!isOrderPlaced">
              Would you like to submit your order before proceeding to invoice?
            </p>
          </div>
        </div>

        <div class="pointer flex-end-center" (click)="handleClosePartsAccordion()">
          <i class="pl-2 fa" [ngClass]="[closePartsAccordion ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </div>
      <div class="vehicle-body" *ngIf="closePartsAccordion">
        <!-- NEXTPART START-->
        <app-authorization-parts-ordering [isArchived]="order.isArchived" [setPartsTechQoutes]="setPartsTechQoutes"
          [setManualQoutes]="setManualQoutes" [setNexpartQoutes]="setNexpartQoutes"
          [isOrderPlaced]="order?.isOrderPlaced" [estimate]="order" [estimateService]="order?.services"
          [partsTechOrderPlacedAt]="order?.partsTechOrderPlacedAt" [partsTechLastSynced]="order?.partsTechLastSynced"
          [partsTechSessionId]="order?.partsTechSessionId" [partsTechQoutes]="order?.partsTechQoutes"
          [nexpartQoutes]="order?.nexpartQoutes" [manualQoutes]="order?.manualQoutes" [estimate]="order"
          [isNexpartEnabled]="isNexpartEnabled" [isPartsTechEnabled]="isPartsTechEnabled"
          [isFinalizedRo]="isFinalizedRo" [isManualPartOrderingEnabled]="isManualPartOrderingEnabled"
          (getEstimatesById)="getEstimate()" [tags]="serviceTags"
          (addPartsTechPartToService)="addPartsTechPartToService($event)"
          (setReturnCoreTags)="setReturnCoreForPartOrdering($event)" [customFleetSettings]="customFleetSettings"
          (updateOrderServices)="_updateServiceAndTotal(false, true)" (syncPartsTechParts)="syncPartsTechParts($event)"
          (appUpdateManualItemOrder)="checkOrderPlace($event)" [dialogOpenFrom]="dialogOpenFrom">
        </app-authorization-parts-ordering>
        <!-- NEXTPART END-->
      </div>
    </div>

    <!-- PARTS ORDERING END-->



    <!-- <div class="vehicle-info"> -->
    <!-- <app-auth-pending-ordered-carts [orderId]="estimateId"></app-auth-pending-ordered-carts> -->
    <!-- </div> -->

    <!-- Core Item -start -->
    <div class="vehicle-info" *ngIf="hasItemWithCore">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <span class="fa-stack">
            <i class="fa-ellipsis-h fa-stack-1x far"></i>
          </span>

          <div class="vehicle-heading">
            <h3>Core <span class="pill pill-recomended flex-center-center">Recommended</span></h3>
            <p class="m-0 font-gray-55">Would you like to update the core status of items before invoicing.</p>
          </div>
        </div>

        <div class="flex-center-center"
          (click)="$event.stopPropagation(); closeCorePartAccordian = !closeCorePartAccordian">
          <i class="pl-2 pointer fa" [ngClass]="[closeCorePartAccordian ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </div>

      <div class="vehicle-body" *ngIf="closeCorePartAccordian && order?._id && hasItemWithCore">
        <app-authorization-core-parts [orderWithCoreItems]="orderWithCoreItems"></app-authorization-core-parts>
      </div>
    </div>
    <!-- Core Item - end -->

    <!-- Credit Limit Section start -->
    <div class="vehicle-info"
      *ngIf="showInvoiceButton() && hasCreditLimitSection && !isRevenueRecognitionSettleEnabled">
      <div class="vehicle-head">
        <div class="vehicle-title">
          <i [ngClass]="getCreditLimitIconClass()"></i>
          <div class="vehicle-heading">
            <h3>Insufficient credit limit</h3>
            <p class="m-0 font-gray-55 width-80p">
              {{order?.customer?.displayName }} has insufficient Credit limit for this order
              (RO amount: {{order?.total?.grand | currency : usd}} | Available
              Credit Limit: {{availableLimit | currency : usd}}).
              Mark “Safe to Invoice” to proceed.
            </p>
          </div>
        </div>
        <div *ngIf="!hasSafeToInvoice">
          <button class="btn safe-invoice-button pointer mx-2" (click)="handleSafeToInvoice()">
            <span class="pr-1">Safe to Invoice</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Credit Limit Section start -->


  </div>


  <div class="loading-body" *ngIf="isSyncingToQuickbooks">
    <app-service-authorization-skeleton [isServiceAuthorization]="true"></app-service-authorization-skeleton>
    <div *ngIf="isProcessingToQBO" class="loading-qbo">
      <i class="p-2 fal fa-spinner rotate"></i>
      <div class="mt-4 gray-55 font-16">Updating RO status to invoice</div>
    </div>
  </div>

  <div class="service-authorization-dialog-footer">
    <p *ngIf="hasNegativeBalance" class="m-0 negative-balance-error font-600">
      Action not allowed. This action will result in negative Remaining balance.
    </p>

    <div class="flex-between-center">
      <button class="btn btn-border pointer btn-submit mr-1" [ngClass]="!showLeftCancel() ? 'hidden' : 'visible'"
        (click)="handleClose()">
        Cancel
      </button>

      <div class="flex-end-center">
        <button *ngIf="showRightCancel()" class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">
          Cancel
        </button>

        <button *ngIf="showAuthorizeButton()" class="btn btn-primary btn-submit" tooltipPosition="top"
          [pTooltip]="isFinalizedRo ? 'Sorry, cannot make changes to a finalized RO' : ''"
          [disabled]="isValidateAuthorizeButton()" (click)="handleSubmit(true)">
          <span [ngClass]="{ 'pr-2': isProcessingAuthorization }">Authorize</span>
          <i class="fal fa-spinner rotate" *ngIf="isProcessingAuthorization"></i>
        </button>

        <button *ngIf="showPaymentButton()" class="btn btn-primary btn-submit"
          [disabled]="isProcessing || isFetchingData" (click)="openPaymentDialog()">
          <span>Proceed to Payment</span>
        </button>

        <button *ngIf="MFCValidations && openFrom === 'finalize'" class="btn btn-primary btn-submit mr-1"
          [disabled]="isValidPostToMyFleetButton() || isFetchingData"
          [ngClass]="{ 'not-allowed': isValidPostToMyFleetButton() }" (click)="postToMyFleet()">
          <span class="pr-1">Finalize and post to MyFleetCenter</span>
          <i class="fa fa-spinner rotate" *ngIf="isProcessingAuthorization"></i>
        </button>

        <button *ngIf="MFCValidations && openFrom === 'RO'" class="btn btn-primary btn-submit mr-1"
          [disabled]="isValidPostToMyFleetButton() || isFetchingData"
          [ngClass]="{ 'not-allowed': isValidPostToMyFleetButton() }" (click)="postToMyFleet(true)">
          <span>Post to MyFleetCenter</span>
          <i class="fa fa-spinner rotate" *ngIf="isLoading"></i>
        </button>

        <button *ngIf="showInvoiceButton()" class="btn invoice-button pointer mx-2"
          [ngClass]="{ 'not-allowed': isValidate() }" [disabled]="isValidate() || isLoading || isFetchingData"
          (click)="sendInvoice()">
          <span class="pr-1">Invoice</span>
          <i class="fa fa-spinner rotate" *ngIf="isLoading"></i>
        </button>

        <span *ngIf="!isRevenueRecognitionSettleEnabled">
          <button *ngIf="showInvoiceButton() && isQboConnected" class="btn btn-primary btn-submit mr-1"
            [ngClass]="{ 'not-allowed': isValidate() || (this.isRevenueRecognitionSettleEnabled  && !this.isFinalizedRo) }"
            [disabled]="isValidate() || (this.isRevenueRecognitionSettleEnabled  && !this.isFinalizedRo) || isFetchingData"
            (click)="sendInvoiceToQBO()">
            <img src="assets/img/icon/qbo-btn.png" class="quickbooks-btn mr-1" alt="quickbooks" />
            <span>Invoice and Post to QBO</span>
          </button>
        </span>
      </div>
    </div>
  </div>
</div>